import React from "react";

export const UiCardTitle = (props) => {
    return (
        <>
            <h2 className="sb-card-main-title">
                {props.title}
                {
                    props.underlined && <span className="sb-card-main-title__underline"></span>
                }
                {
                    props.fullyUnderlined &&  <span className="sb-card-main-title__underline-full"></span>
                }
            </h2>
        </>
    )
}